import { authorizedFetch, abortAllPendingRequests, clearLoggedInCookie } from "@/lib/api";

// Define the base URL of our FastAPI backend
const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || "http://127.0.0.1:8000";

// Validate: non-localhost domains MUST use HTTPS. This is not optional.
const isLocalhost =
  API_BASE_URL.includes("127.0.0.1") || API_BASE_URL.includes("localhost");
if (!isLocalhost && API_BASE_URL.startsWith("http://")) {
  const errorMsg = `[CRITICAL] API_BASE_URL must use HTTPS, not HTTP. Got: ${API_BASE_URL}\n\nThis is a deployment configuration error. Check that VITE_API_BASE_URL environment variable in Cloudflare Pages is set to: https://api.oitava.app (with HTTPS, not HTTP)`;
  console.error(errorMsg);
  // Always throw - this is a security/CSP issue, not a warning
  throw new Error(errorMsg);
}

export { API_BASE_URL, authorizedFetch, abortAllPendingRequests, clearLoggedInCookie };
